/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Show_PasswordInputs */

const vi_auth_show_password = /** @type {(inputs: Auth_Show_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện mật khẩu`)
};

/**

* @param {Auth_Show_PasswordInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const auth_show_password = /** @type {((inputs?: Auth_Show_PasswordInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Show_PasswordInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_auth_show_password(inputs)
});